import React from "react";
import Loder from "../../icons/new_loader.gif";

const LoaderSpiner = ({ text, subtext }) => {
  return (
    <div>
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
        <div className="bg-white shadow-lg text-center  w-[13%] flex justify-center items-center flex-col rounded-lg">
          {/* <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-gray-900"></div> */}
          {/* <p className="mt-4 text-2xl text-gray-800">{text}</p>
          {subtext && <p className="mt-1 text-gray-800">{subtext}</p>} */}
          <img
            src={Loder}
            alt="loader"
            className="text-xl text-gray-800 rounded-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default LoaderSpiner;
